import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';

const ICONS = {
  arrow: (<><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></>),
  down: (<><line x1="12" y1="5" x2="12" y2="19" /><polyline points="19 12 12 19 5 12" /></>),
  file: (<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /></>),
  send: (<><line x1="22" y1="2" x2="11" y2="13" /><polygon points="22 2 15 22 11 13 2 9 22 2" /></>),
  calendar: (<><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></>),
};

const Icon = ({ name, className = '' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {ICONS[name]}
  </svg>
);

/* ---- Arayüz önizlemeleri için örnek içerik (gerçek veri değildir) ---- */
const SIDEBAR = [
  { name: 'Veri Yapıları', tone: 'ders', unread: 3, active: true },
  { name: 'Bitirme Projesi', tone: 'proje' },
  { name: 'Final Hazırlık', tone: 'sinav' },
  { name: 'Kampüs Duyuruları', tone: 'genel' },
];

const CHAT = [
  { who: 'Zeynep', initial: 'Z', text: 'Ağaç yapıları özetini kaynak havuzuna yükledim.', time: '14:02' },
  { who: 'Mert', initial: 'M', text: 'Çok iyi olmuş, teşekkürler. Vize tarihini takvime de ekliyorum.', time: '14:05' },
  { me: true, text: 'Pazartesi soru çözümü için ben bir oturum açayım.', time: '14:06' },
];

const GROUP_CARDS = [
  { name: 'Algoritma Çalışma Grubu', tone: 'ders', tag: 'Ders', desc: 'Haftalık soru çözümleri ve ders notları.', members: 18, joined: true },
  { name: 'Bitirme Projesi Ekibi', tone: 'proje', tag: 'Proje', desc: 'Görev dağılımı ve toplantı notları.', members: 5, joined: true },
  { name: 'Final Hazırlık', tone: 'sinav', tag: 'Sınav', desc: 'Çıkmış sorular ve konu özetleri.', members: 42, joined: false },
];

const FILES = [
  { name: 'Agac_Yapilari_Ozet.pdf', by: 'Zeynep', size: '1,2 MB' },
  { name: 'Vize_Cikmis_Sorular.pdf', by: 'Mert', size: '3,4 MB' },
  { name: 'Proje_Sunumu.pptx', by: 'Ayşe', size: '5,8 MB' },
];

const WEEKDAYS = ['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt', 'Paz'];
const CAL_EVENTS = { 9: 'proje', 14: 'sinav', 21: 'ders', 27: 'proje' };
const EVENT_LIST = [
  { day: 9, title: 'Proje teslimi', tone: 'proje' },
  { day: 14, title: 'Veri Yapıları vizesi', tone: 'sinav' },
  { day: 21, title: 'Sunum günü', tone: 'ders' },
];

// Takvim önizlemesi her zaman içinde bulunulan ayı gösterir (Pazartesi ilk gün)
const buildCalendar = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  const offset = (new Date(y, m, 1).getDay() + 6) % 7;
  const days = new Date(y, m + 1, 0).getDate();
  return {
    title: now.toLocaleDateString('tr-TR', { month: 'long', year: 'numeric' }),
    monthShort: now.toLocaleDateString('tr-TR', { month: 'short' }),
    monthLong: now.toLocaleDateString('tr-TR', { month: 'long' }),
    today: now.getDate(),
    year: y,
    cells: [...Array(offset).fill(null), ...Array.from({ length: days }, (_, i) => i + 1)],
  };
};

const FOOTER_LINKS = {
  authed: [
    ['/groups', 'Gruplar'],
    ['/chat', 'Sohbet'],
    ['/upload', 'Kaynak havuzu'],
    ['/calendar', 'Takvim'],
    ['/profile', 'Profil'],
  ],
  guest: [
    ['/login', 'Giriş yap'],
    ['/register', 'Kayıt ol'],
  ],
};

/* Giriş yapmamış kullanıcıya bağlantı gösterilmez; yalnızca açıklama kalır */
const MoreItem = ({ authed, to, title, text, cta }) => {
  const body = (
    <>
      <h3>{title}</h3>
      <p>{text}</p>
      {authed && <span className="hm-link">{cta} <Icon name="arrow" className="hm-link-icon" /></span>}
    </>
  );
  return authed
    ? <Link to={to} className="hm-more-item">{body}</Link>
    : <div className="hm-more-item">{body}</div>;
};

function Home() {
  const token = localStorage.getItem('token');
  const cal = useMemo(buildCalendar, []);
  const footerLinks = token ? FOOTER_LINKS.authed : FOOTER_LINKS.guest;

  return (
    <div className="hm-page">
      <main>
        {/* ================= Hero ================= */}
        <section className="hm-hero">
          <div className="hm-container hm-hero-grid">
            <div className="hm-hero-copy">
              <span className="hm-label">Öğrenci platformu</span>
              <h1>
                Çalışma grubunuz için <span className="hm-mark">tek bir yer.</span>
              </h1>
              <p className="hm-lead">
                Dersiniz, projeniz ya da sınavınız için grup kurun. Sohbet edin, notları paylaşın,
                önemli tarihleri aynı yerden takip edin.
              </p>

              <div className="hm-actions">
                {token ? (
                  <>
                    <Link to="/groups" className="hm-btn hm-btn-solid">Gruplarına git</Link>
                    <Link to="/chat" className="hm-link">Sohbete geç <Icon name="arrow" className="hm-link-icon" /></Link>
                  </>
                ) : (
                  <>
                    <Link to="/register" className="hm-btn hm-btn-solid">Ücretsiz başla</Link>
                    <Link to="/login" className="hm-link">Giriş yap <Icon name="arrow" className="hm-link-icon" /></Link>
                  </>
                )}
              </div>

              <a href="#ozellikler" className="hm-scroll-hint">
                Neler yapabilirsiniz? <Icon name="down" className="hm-link-icon" />
              </a>
            </div>

            {/* Uygulama önizlemesi */}
            <div className="hm-hero-visual" aria-hidden="true">
              <div className="hm-frame">
                <div className="hm-frame-bar">
                  <span className="hm-dot" /><span className="hm-dot" /><span className="hm-dot" />
                  <span className="hm-address">educonnect / sohbet</span>
                </div>
                <div className="hm-app">
                  <aside className="hm-side">
                    {SIDEBAR.map((s) => (
                      <div key={s.name} className={`hm-side-row${s.active ? ' is-active' : ''}`}>
                        <span className="hm-tone-dot" data-tone={s.tone} />
                        <span className="hm-side-name">{s.name}</span>
                        {s.unread && <span className="hm-unread">{s.unread}</span>}
                      </div>
                    ))}
                  </aside>
                  <div className="hm-chat">
                    <div className="hm-chat-head">
                      <strong>Veri Yapıları</strong>
                      <span>18 üye</span>
                    </div>
                    <div className="hm-chat-body">
                      {CHAT.map((m, i) => (
                        <div key={i} className={`hm-msg${m.me ? ' is-me' : ''}`}>
                          {!m.me && <span className="hm-avatar" data-who={m.initial}>{m.initial}</span>}
                          <div className="hm-bubble">
                            {!m.me && <span className="hm-msg-who">{m.who}</span>}
                            <p>{m.text}</p>
                            <time>{m.time}</time>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="hm-chat-input">
                      <span>Mesaj yaz…</span>
                      <Icon name="send" className="hm-send" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="hm-chip hm-chip-file">
                <Icon name="file" className="hm-chip-icon" />
                <div><b>Agac_Yapilari_Ozet.pdf</b><span>Kaynak havuzuna eklendi</span></div>
              </div>
              <div className="hm-chip hm-chip-date">
                <Icon name="calendar" className="hm-chip-icon" />
                <div><b>14 {cal.monthLong} · Vize</b><span>Veri Yapıları</span></div>
              </div>
            </div>
          </div>
        </section>

        {/* ================= Özellikler ================= */}
        <section id="ozellikler" className="hm-features">
          {/* Gruplar */}
          <div className="hm-container hm-row">
            <div className="hm-row-copy">
              <span className="hm-label">Gruplar</span>
              <h2>Her ders, proje ve sınav için ayrı bir oda.</h2>
              <p>
                Grubunuzu kategoriye göre açın, arkadaşlarınızı bekleyin. Katıldığınız gruplar tek
                listede; yöneticisi ve üye sayısıyla birlikte görünür.
              </p>
              {token && (
                <Link to="/groups" className="hm-link">
                  Gruplara göz at <Icon name="arrow" className="hm-link-icon" />
                </Link>
              )}
            </div>
            <div className="hm-panel" aria-hidden="true">
              {GROUP_CARDS.map((g) => (
                <div key={g.name} className="hm-gcard">
                  <div className="hm-gcard-top">
                    <strong>{g.name}</strong>
                    <span className="hm-tag" data-tone={g.tone}>{g.tag}</span>
                  </div>
                  <p>{g.desc}</p>
                  <div className="hm-gcard-foot">
                    <span>{g.members} üye</span>
                    <span className={g.joined ? 'hm-state' : 'hm-state is-join'}>
                      {g.joined ? 'Üyesiniz' : 'Katıl'}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Kaynak havuzu */}
          <div className="hm-container hm-row is-reverse">
            <div className="hm-row-copy">
              <span className="hm-label">Kaynak havuzu</span>
              <h2>Notlar mesaj geçmişinde kaybolmasın.</h2>
              <p>
                Ders notlarını, ödevleri ve kaynakları yükleyin. İhtiyacı olan arkadaşlarınız tek
                yerden ulaşsın.
              </p>
              {token && (
                <Link to="/upload" className="hm-link">
                  Kaynak havuzuna git <Icon name="arrow" className="hm-link-icon" />
                </Link>
              )}
            </div>
            <div className="hm-panel" aria-hidden="true">
              <div className="hm-files">
                {FILES.map((f) => (
                  <div key={f.name} className="hm-file">
                    <span className="hm-file-icon"><Icon name="file" className="hm-file-svg" /></span>
                    <div className="hm-file-info">
                      <b>{f.name}</b>
                      <span>{f.by} · {f.size}</span>
                    </div>
                    <span className="hm-file-action">İndir</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Takvim */}
          <div className="hm-container hm-row">
            <div className="hm-row-copy">
              <span className="hm-label">Etkinlik takvimi</span>
              <h2>Sınav ve teslim tarihleri gözünüzün önünde.</h2>
              <p>
                Ders programınızı, sınav tarihlerinizi ve önemli etkinlikleri düzenleyin; hiçbir
                tarihi son güne bırakmayın.
              </p>
              {token && (
                <Link to="/calendar" className="hm-link">
                  Takvimi aç <Icon name="arrow" className="hm-link-icon" />
                </Link>
              )}
            </div>
            <div className="hm-panel" aria-hidden="true">
              <div className="hm-cal">
                <div className="hm-cal-head"><strong>{cal.title}</strong></div>
                <div className="hm-cal-grid">
                  {WEEKDAYS.map((d) => <span key={d} className="hm-cal-wd">{d}</span>)}
                  {cal.cells.map((d, i) => (
                    <span
                      key={i}
                      className={`hm-cal-day${d ? '' : ' is-empty'}${d === cal.today ? ' is-today' : ''}`}
                      data-tone={CAL_EVENTS[d] || undefined}
                    >
                      {d}
                    </span>
                  ))}
                </div>
                <ul className="hm-events">
                  {EVENT_LIST.map((e) => (
                    <li key={e.title}>
                      <span className="hm-tone-dot" data-tone={e.tone} />
                      <b>{e.day} {cal.monthShort}</b>
                      <span>{e.title}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Diğer araçlar */}
          <div className="hm-container">
            <div className="hm-more">
              <MoreItem
                authed={!!token}
                to="/chat"
                title="Anlık iletişim"
                text="Gruplarla ya da birebir sohbetlerle bağlantıda kalın."
                cta="Sohbete git"
              />
              <MoreItem
                authed={!!token}
                to="/profile"
                title="Kişisel profil"
                text="Kişisel ve akademik bilgilerinizi güncel tutun, profil fotoğrafınızı ekleyin."
                cta="Profile git"
              />
            </div>
          </div>
        </section>

        {/* ================= Hakkında / çağrı ================= */}
        <section className="hm-about">
          <div className="hm-container hm-about-grid">
            <div>
              <h2>Öğrencilerin ihtiyacı olan araçlar, <em>tek çatı altında.</em></h2>
            </div>
            <div>
              <p>
                EduConnect, ders çalışırken dağınık kalan sohbet, dosya ve takvim ihtiyacını tek bir
                web uygulamasında toplamak için geliştirilmiş bir eğitim platformudur. Arayüz
                masaüstünde ve mobilde aynı rahatlıkla kullanılır.
              </p>
              {!token && (
                <Link to="/register" className="hm-btn hm-btn-light">Hesap oluşturun</Link>
              )}
            </div>
          </div>
        </section>
      </main>

      <footer className="hm-footer">
  <div className="hm-container hm-footer-inner">
    <p>© 2026 EduConnect. Tüm hakları saklıdır.</p>
  </div>
</footer>
    </div>
  );
}

export default Home;